<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <a-pagination
      :total="total"
      :show-total="total => `共 ${total} 条`"
      v-bind="$attrs"
      v-model="currentPage"
      :page-size.sync="currentPageSize"
      :page-size-options="pageSizeOptions"
      :show-size-changer="showSizeChanger"
      :show-quick-jumper="showQuickJumper"
      @change="handleCurrentChange"
      @showSizeChange="handleSizeChange"
    />
  </div>
</template>

<script>

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    current: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizeOptions: {
      type: Array,
      default() {
        return ['10', '20', '30', '50', '100']
      }
    },
    showSizeChanger: {
      type: Boolean,
      default: true
    },
    showQuickJumper: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.current
      },
      set(val) {
        this.$emit('update:current', val)
      }
    },
    currentPageSize: {
      get() {
        return this.pageSize
      },
      set(val) {
        this.$emit('update:pageSize', val)
      }
    }
  },
  methods: {
    handleSizeChange(current, size) {
      this.$emit('update:current', current)
      this.$emit('pagination', { current, pageSize: size })
    },
    handleCurrentChange(page, pageSize) {
      this.$emit('update:current', page)
      this.$emit('pagination', { current: page, pageSize })
    }
  }
}
</script>

<style scoped>
  .pagination-container {
    background: #fff;
    padding: 16px;
    display: flex;
    justify-content: flex-end;
    /* background: pink; */
  }
  .pagination-container.hidden {
    display: none;
  }
</style>

<!--
引入分页组件
import Pagination from '@/components/Pagination'

  使用
  <div class="table-wrap">
    <a-table class="table"></a-table>
    <pagination
      size="small"
      :hidden="page.total == 0"
      :total="page.total"
      :current.sync="page.current"
      :page-size.sync="page.pageSize"
      @pagination="search"
    />
  </div>
-->